import { REDUX_API_GATEWAY_ACTIONS } from '../constants/apiGateWayConstant';

// intiate store constant
import STORE_INITIATE_VALUE from '../constants/initialstore';

export default (state = STORE_INITIATE_VALUE.EDITING_REPORT, action) => {
  switch (action.type) {
    case REDUX_API_GATEWAY_ACTIONS.GET_EDITING_REPORT_SUCCESS:
      if (action.payload === undefined || action.payload === null || Object.keys(action.payload).length === 0) {
        return {
          ...state,
          editingReport: null,
        };
      }
      return {
        ...state,
        editingReport: action.payload.data[0].attributes,
      };
    case REDUX_API_GATEWAY_ACTIONS.UPDATE_REPORT_SUCCESS:
      return {
        ...state,
        editingReport: null,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/editingReport.js